import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import { TransactionsStore } from '../../mobx-store/stores/transactionsStore';
import {
  WithSnackbarProps,
} from 'notistack';
import {
  fawryTransactions,
  sapTransactions,
  SapTransactionLogs,
  DeglawyPointsTransaction,
  PaymobTransaction,
} from '../../mobx-store/storeInterfaces/transactionInterface';
import moment from 'moment';
import GeneralViewModal from 'components/modals/generalViewModal';
import { translate } from 'helperFunctions/translation';
import { Button, TextField } from '@material-ui/core';
import classes from './transactions.module.scss';

interface IProps extends WithSnackbarProps{
  history: any;
  transactionsStore: TransactionsStore;
  match: any
}

interface IState {
  openSapLogsModal: boolean;
  selectedSapTransactionLog: SapTransactionLogs[];
  openManualNotificationModal: boolean;
  manualNotificationDocumentCodeOData: string;
  selectedSapTransaction: sapTransactions;
}

@inject('transactionsStore')
@observer
class TransactionsDetails extends Component<IProps, IState> {

  dateFormat = 'YYYY-MM-DD HH:mm';

  fawryTableHeader: any = [];
  fawryTableData: any[] = [];
  fawryTableCellTypes: TableCellTypes[] = [];

  paymobTableHeader: any = [];
  paymobTableData: any[] = [];
  paymobTableCellTypes: TableCellTypes[] = [];

  sapTableHeader: any = [];
  sapTableData: any[] = [];
  sapTableCellTypes: TableCellTypes[] = [];

  pointsTableHeader: any = [];
  pointsTableData: any[] = [];
  pointsTableCellTypes: TableCellTypes[] = [];

  constructor(props: IProps) {
    super(props);
    this.state = {
      openSapLogsModal: false,
      selectedSapTransactionLog: [],
      openManualNotificationModal: false,
      manualNotificationDocumentCodeOData: '',
      selectedSapTransaction: {
        documentCategoryCode: '',
        documentCode: '',
        documentCategoryName: '',
        documentCodeOData: '',
        documentCompanyCode: '',
        documentDueDate: new Date(),
        isSapNotified: false,
        amount: 0,
        createdAt: new Date(),
        updatedAt: new Date(),
        sapTransactionLogs:[],
      },
    };
    this.openSapTransactionsLogsModal = this.openSapTransactionsLogsModal.bind(this);
    this.openManualNotificationModal = this.openManualNotificationModal.bind(this);
  }


  async componentWillMount () {
    await this.props.transactionsStore.getTransactionById(this.props.match.params.id);
  }

  getFawaryTransactionTableHeader = () => {
    return [
      {
        title: 'transaction Id',
      },
      {
        title: 'fawry Order Id',
      },
      {
        title: 'status',
      },
      {
        title: 'amount',
      },
      {
        title: 'created At',
      }
    ];
  }
  getFawaryTransactionTableData = () => {
    return this.props.transactionsStore.selectedTransaction.fawryTransactions
      .map((transaction: fawryTransactions) => {
        const transactionData = {
          transactionId: transaction.incrementId,
          fawryOrderId: transaction.fawryOrderId,
          status: transaction.status,
          amount: transaction.amount,
          createdAt: moment(transaction.createdAt).format(this.dateFormat),
        };
        return transactionData;
      });
  }

  getFawaryTransactionTableCellTypes = (): TableCellTypes[] =>  {
    return  [
      {
        cellType: 'Text',
        key: 'transactionId',
      },
      {
        cellType: 'Text',
        key: 'fawryOrderId',
      },
      {
        cellType: 'Text',
        key: 'status',
      },
      {
        cellType: 'Text',
        key: 'amount',
      },
      {
        cellType: 'Text',
        key: 'createdAt',
      }
    ];
  };

  getPaymobTransactionTableHeader = () => ([
    {
      title: 'Transaction ID',
    },
    {
      title: 'Paymob Transaction ID',
    },
    {
      title: 'Status',
    },
    {
      title: 'Created At',
    },
  ]);

  getPaymobTransactionTableData = () => {
    return this.props.transactionsStore.selectedTransaction.paymobTransactions
      .map((transaction: PaymobTransaction) => {
        const transactionData = {
          transactionId: transaction.incrementId,
          paymobTransactionId: transaction.paymobTransactionId,
          status: transaction.status,
          createdAt: moment(transaction.createdAt).format(this.dateFormat),
        };
        return transactionData;
      });
  };

  getPaymobTransactionTableCellTypes = (): TableCellTypes[] => ([
    {
      cellType: 'Text',
      key: 'transactionId',
    },
    {
      cellType: 'Text',
      key: 'paymobTransactionId',
    },
    {
      cellType: 'Text',
      key: 'status',
    },
    {
      cellType: 'Text',
      key: 'createdAt',
    },
  ]);

  getSAPTransactionTableHeader = () => {
    return [
      {
        title: 'Transaction Id'
      },
      {
        title: 'amount',
      },
      {
        title: 'document Code',
      },
      {
        title: 'is Sap Notified',
      },
      {
        title: 'document Category Code',
      },
      {
        title: 'document Category Name',
      },
      {
        title: 'document Code O Data',
      },
      {
        title: 'created At',
      },
      {
        title: 'Sap Transactions Logs'
      },
      {
        title: 'Manual Notification',
      }
    ];
  };

  getSAPTransactionTableData = () => {
    const selectedTransaction = this.props.transactionsStore.selectedTransaction
    return selectedTransaction.sapTransactions
      .map((transaction: sapTransactions) => {
        const transactionData = {
          transactionId: selectedTransaction.transactionId,
          amount: transaction.amount,
          documentCode: transaction.documentCode,
          isSapNotified: transaction.isSapNotified ? 'True' : 'False',
          documentDueDate: transaction.documentDueDate,
          documentCategoryCode: transaction.documentCategoryCode,
          documentCategoryName: transaction.documentCategoryName,
          documentCodeOData: transaction.documentCodeOData,
          documentCompanyCode: transaction.documentCompanyCode,
          createdAt: moment(transaction.createdAt).format(this.dateFormat),
          sapTransactionsLogs : 'Details',
          manualNotification: 'Notify',
        };
        return transactionData;
      });
  }

  getSAPTransactionTableCellTypes = (): TableCellTypes[] =>  {
    return  [
      {
        cellType: 'Text',
        key: 'transactionId'
      },
      {
        cellType: 'Text',
        key: 'amount',
      },
      {
        cellType: 'Text',
        key: 'documentCode',
      },
      {
        cellType: 'Text',
        key: 'isSapNotified',
      },
      {
        cellType: 'Text',
        key: 'documentCategoryCode',
      },
      {
        cellType: 'Text',
        key: 'documentCategoryName',
      },
      {
        cellType: 'Text',
        key: 'documentCodeOData',
      },
      {
        cellType: 'Text',
        key: 'createdAt',
      },
      {
        cellType: 'Button',
        key: 'sapTransactionsLogs',
        onClick: this.openSapTransactionsLogsModal
      },
      {
        cellType: 'Button',
        key: 'manualNotification',
        onClick: this.openManualNotificationModal,
        disabled: this.disableManualNotification,
      }
    ];
  }

  disableManualNotification = (index: number) => {
    const transaction = this.props.transactionsStore.selectedTransaction.sapTransactions[index];

    return !!transaction.documentCodeOData || transaction.documentCodeOData?.length > 0; 
  };

  getPointsTransactionTableHeader = () => {
    return [
      {
        title: 'Transaction Id',
      },
      {
        title: 'Dsquares Transaction Id',
      },
      {
        title: 'Status',
      },
      {
        title: 'Amount',
      },
      {
        title: 'Created At',
      }
    ];
  }

  getPointsTransactionTableData = () => {
    return this.props.transactionsStore.selectedTransaction.deglawyPointsTransactions
      .map((transaction: DeglawyPointsTransaction) => {
        const transactionData = {
          transactionId: transaction.id,
          dsquaresTransactionId: transaction.dsquaresTransactionId,
          status: transaction.status,
          amount: transaction.amount,
          createdAt: moment(transaction.createdAt).format(this.dateFormat),
        };
        return transactionData;
      });
  }

  getPointsTransactionTableCellTypes = (): TableCellTypes[] =>  {
    return  [
      {
        cellType: 'Text',
        key: 'transactionId',
      },
      {
        cellType: 'Text',
        key: 'dsquaresTransactionId',
      },
      {
        cellType: 'Text',
        key: 'status',
      },
      {
        cellType: 'Text',
        key: 'amount',
      },
      {
        cellType: 'Text',
        key: 'createdAt',
      }
    ];
  }

  openSapTransactionsLogsModal(index: number, key: string) {
    const selectedSapTransactionLog = this.props.transactionsStore.selectedTransaction
       .sapTransactions[index].sapTransactionLogs
       .map(sapTransaction => {
        sapTransaction.createdAt = moment(sapTransaction.createdAt).format('YYYY-MM-DD HH:mm:ss');
        sapTransaction.responseError = this.mapSapLogsErrorsResponse(sapTransaction.response);
        return sapTransaction;
      })

    this.setState({
      openSapLogsModal: true,
      selectedSapTransactionLog
    })
  }

  openManualNotificationModal(index: number, key: string) {
    this.setState({
      openManualNotificationModal: true,
      selectedSapTransaction: this.props.transactionsStore.selectedTransaction.sapTransactions[index],
    })
  }

  mapSapLogsErrorsResponse(response: string): string {
    switch(response) {
      case '1': return translate('sapLogsErrorBlocked ' , {});

      case '2':
      case 'B': return translate('sapLogsErrorPaidBefore' , {});

      case '3': return translate('sapLogsErrorNoOpenItems ' , {});

      case '4':
      case 'S': return translate('sapLogsErrorPaid' , {});

      case '5':
      case 'W': return translate("sapLogsErrorSomethingwrong" , {});
      default: return response;
    }
  }

  sapTransactionsLogsTable(): JSX.Element {
    return (
      <>
        <GeneralTableComponent
          emptyMessage="No Transactions Logs Found"
          tableHeader={
            [
              {
                title: 'Id'
              },
              {
                title: 'Response'
              },
              {
                title: 'Error'
              },
              {
                title: 'Created at'
              }
            ]
          }
          tableData={this.state.selectedSapTransactionLog}
          tableCellTypes={
            [
              {
                key: 'sapTransactionLogId',
                cellType: 'Text'
              },
              {
                key: 'response',
                cellType: 'Text'
              },
              {
                key: 'responseError',
                cellType: 'Text'
              },
              {
                key: 'createdAt',
                cellType: 'Text'
              }
            ]
          }
        />
      </>
    );
  }

  notifySapManually = async () => {
    await this.props.transactionsStore.notifySapTransactionManually(
      this.props.transactionsStore.selectedTransaction.transactionId as number,
      this.state.selectedSapTransaction.documentCode,
      this.state.manualNotificationDocumentCodeOData
    );
    this.setState({openManualNotificationModal: false, manualNotificationDocumentCodeOData: ''});
    await this.props.transactionsStore.getTransactionById(this.props.match.params.id);
  }

  documentCodeODataInput(): JSX.Element {
    return (
      <div>
       <div>
          <TextField
            className={classes.input}
            placeholder={'5020000042'}
            value={this.state.manualNotificationDocumentCodeOData}
            label={'Doc Code OData'}
            onChange={(text) => {
              this.setState({manualNotificationDocumentCodeOData: text.target.value});
            }}
          />
        </div>
        <br/>
        <div>
          <Button
            onClick={this.notifySapManually} 
            color="primary"
            variant="contained">
              Notify
          </Button>
        </div>
      </div>
    );
  }

  render () {
    this.fawryTableHeader = this.getFawaryTransactionTableHeader();
    this.fawryTableData = this.getFawaryTransactionTableData();
    this.fawryTableCellTypes = this.getFawaryTransactionTableCellTypes();

    this.paymobTableHeader = this.getPaymobTransactionTableHeader();
    this.paymobTableData = this.getPaymobTransactionTableData();
    this.paymobTableCellTypes = this.getPaymobTransactionTableCellTypes();

    this.sapTableHeader = this.getSAPTransactionTableHeader();
    this.sapTableData = this.getSAPTransactionTableData();
    this.sapTableCellTypes = this.getSAPTransactionTableCellTypes();

    this.pointsTableHeader = this.getPointsTransactionTableHeader();
    this.pointsTableData = this.getPointsTransactionTableData();
    this.pointsTableCellTypes = this.getPointsTransactionTableCellTypes();

    return (
      <div>
        {this.props.transactionsStore.selectedTransaction.fawryTransactions.length > 0
          && (
            <div>
              Fawry Transactions
              <GeneralTableComponent
                emptyMessage="No Transactions Found"
                tableHeader={this.fawryTableHeader}
                tableData={this.fawryTableData}
                tableCellTypes={this.fawryTableCellTypes}
                loading={this.props.transactionsStore!.loading}
              />
            </div>
          )}
        {this.props.transactionsStore.selectedTransaction.paymobTransactions.length > 0
          && (
            <div>
              Paymob Transactions
              <GeneralTableComponent
                emptyMessage="No Transactions Found"
                tableHeader={this.paymobTableHeader}
                tableData={this.paymobTableData}
                tableCellTypes={this.paymobTableCellTypes}
                loading={this.props.transactionsStore!.loading}
              />
            </div>
          )}
        {this.props.transactionsStore.selectedTransaction.deglawyPointsTransactions.length > 0
          && (
            <div>
              Points Transactions
              <GeneralTableComponent
                emptyMessage="No Transactions Found"
                tableHeader={this.pointsTableHeader}
                tableData={this.pointsTableData}
                tableCellTypes={this.pointsTableCellTypes}
                loading={this.props.transactionsStore!.loading}
              />
            </div>
          )}
        {this.props.transactionsStore.selectedTransaction.sapTransactions.length > 0
        && (
          <>
            <h3>SAP Transactions</h3>
            <GeneralTableComponent
              emptyMessage="No Transactions Found"
              tableHeader={this.sapTableHeader}
              tableData={this.sapTableData}
              tableCellTypes={this.sapTableCellTypes}
              loading={this.props.transactionsStore!.loading}
            />
            <GeneralViewModal
              open={this.state.openSapLogsModal}
              content={this.sapTransactionsLogsTable()}
              title={translate('sapTransactionsLogs' , {})}
              handleClose={() => this.setState({openSapLogsModal: false})}
            />
            <GeneralViewModal
              open={this.state.openManualNotificationModal}
              content={this.documentCodeODataInput()}
              title="Enter Document Code OData"
              handleClose={() => this.setState({openManualNotificationModal: false})}
            />
          </>
        )}
      </div>
    );
  }
}

export default TransactionsDetails;
